export enum TrainingType {
  secureat = "secureat",
  database = "database",
  distributor = "distributor",
  store = "store",
}
